import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import Rating from '@mui/material/Rating';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Text from 'components/Core/Text';
import RichText from 'components/RichText';
import WebsiteImage from 'components/WebsiteImage';
import { isProd } from 'utils/urlHelper';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return <ArrowForwardIosIcon className={className} style={{ ...style }} onClick={onClick} />;
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return <ArrowBackIosIcon className={className} style={{ ...style }} onClick={onClick} />;
}

const ContentfulSocialProofComponent = (props) => {
  const { company, show, testing } = props;

  if (!show || (testing && isProd)) {
    return null;
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: true,
    nextArrow: <SampleNextArrow className="slick-next custom-arrow" />,
    prevArrow: <SamplePrevArrow className="slick-prev custom-arrow" />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          swipe: true,
        },
      },
    ],
  };

  return (
    <Container>
      <Slider {...settings}>
        {company.map((item, idx) => (
          <div className="social-proof-company" key={idx}>
            <div className="flex flex-col md:flex-row items-start md:items-center gap-[20px]">
              <div className="flex items-center gap-[8px]">
                <div className="w-[24px] h-[24px]">
                  <WebsiteImage
                    {...(item.logo?.fullColor || item.logo?.white[0] || item.logo?.glyph)}
                  />
                </div>
                <div className="flex flex-col items-start">
                  <Text className="m-0 text-white min-w-[120px]" type="p" size="normal">
                    {item.name}
                  </Text>
                  <div className="flex items-center gap-1">
                    <Text className="m-0 leading-100p text-white" type="p" size="small">
                      {item.starRating}
                    </Text>
                    <Rating
                      name="rating"
                      value={item.starRating}
                      precision={0.5}
                      size="small"
                      readOnly
                      sx={{
                        '& .MuiRating-iconFilled': { color: '#fff' },
                        '& .MuiRating-iconEmpty': { color: '#ccc' },
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="text-copy">
                <RichText content={item.copy} className="text-white" />
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </Container>
  );
};

export default ContentfulSocialProofComponent;

const Container = styled.div`
  position: relative;
  margin-top: 20px;

  .text-copy {
    p {
      font-size: 12px;
      font-weight: 400;
      line-height: 120%;
      color: white;
      margin: 0;
    }
  }
  .slick-arrow {
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
    color: #fff;
    &.slick-prev {
      left: -16px;
    }
    &.slick-next {
      right: -16px;
    }
  }
  .slick-slider:hover .slick-arrow {
    opacity: 1;
    pointer-events: auto;
    color: #fff;
  }
  @media (max-width: 750px) {
    margin-bottom: 56px;
    .text-copy {
      p {
        font-size: 14px;
      }
    }
    .website-image {
      margin: 0;
    }
  }
`;
